import { User } from "@models/user.model";

export class ToolStatusHistory {

    public id: number;
    public toolUid: string;
    public toolName: string;
    public user: User;
    public toolStatus: string;
    public toolStance: string;
    public date: string;

    static mapUser(user = {}) {
        return new User(user || {});
    }

    constructor(toolStatusHistory: any = {}) {
        this.id = toolStatusHistory.id || 0;
        this.toolUid = toolStatusHistory.toolUid || '';
        this.toolName = toolStatusHistory.toolName || '';
        this.user = ToolStatusHistory.mapUser(toolStatusHistory.user);
        this.toolStatus = toolStatusHistory.toolStatus || '';
        this.toolStance = toolStatusHistory.toolStance || '';
        this.date = toolStatusHistory.date || '';
    }
}
